import { Api } from '../base/api';
export class WebLarekAPI {
    constructor(cdn, baseUrl, options) {
        this.api = new Api(baseUrl, options);
        this.cdn = cdn;
    }
    async getProducts() {
        return this.api.get('/product/').then((data) => {
            return Object.assign(Object.assign({}, data), { items: data.items.map((item) => {
                    return Object.assign(Object.assign({}, item), { image: `${this.cdn}${item.image}` });
                }) });
        });
    }
    async getProduct(id) {
        return this.api.get(`/product/${id}`).then((data) => (Object.assign(Object.assign({}, data), { image: `${this.cdn}${data.image}` })));
    }
    async postOrder(order) {
        return this.api.post('/order', order, 'POST').then((ctx) => ctx);
    }
}
